'use client';

import SearchIcon from '@mui/icons-material/Search';
import { IconButton } from '@mui/material';

interface MobileSearchToggleProps {
  onClick: () => void;
}

export const MobileSearchToggle = ({ onClick }: MobileSearchToggleProps) => {
  return (
    <IconButton
      onClick={onClick}
      aria-label="Toggle search"
      sx={{ display: { xs: 'flex', md: 'none' }, color: 'text.secondary' }}
    >
      <SearchIcon />
    </IconButton>
  );
};
